import "./src/types";
/* eslint-disable import/export */
import { useDashboardLayoutRedesignEnabled } from "./src/dbbl/businessLogic/modules/dashboard/hooks";
import {
  achPayments,
  alerts,
  aoiob,
  auth,
  cardLimitIncrease,
  customAlerts,
  directDeposit,
  externalAccounts,
  getCategorySlices,
  getDrawnShares,
  getDefaultDateRange,
  getSampleSpendingIncomeReport,
  incomeReporting,
  internationalWires,
  loanPayment,
  MIN_SLICE_SHARE,
  narmiTiles,
  nps,
  onboarding,
  positivePay,
  subscriptions,
  toPercent,
  transfers,
  travelNotes,
  userAccessibilityPreferences,
  userDisplayPreferences,
  userLanguagePreference,
  wireTemplates,
} from "./src/dbbl/businessLogic/modules";
import * as search from "./src/dbbl/businessLogic/modules/search/hooks";

const dashboard = {
  useDashboardLayoutRedesignEnabled,
};

const spendingIncome = {
  getCategorySlices,
  getDrawnShares,
  MIN_SLICE_SHARE,
  getDefaultDateRange,
  getSampleSpendingIncomeReport,
  toPercent,
};

export type { IPlatform } from "./src/dbbl/interfaces/platform.interface";
export { PLATFORM } from "./src/dbbl/interfaces/platform.interface";

export type { INetwork } from "./src/dbbl/interfaces/network.interface";
export type { Network } from "./src/dbbl/interfaces/network.types";
export { ResponseError } from "./src/dbbl/interfaces/network.types";

export type * from "./src/dbbl/interfaces/schema.models";

export type { IToasts } from "./src/dbbl/interfaces/toasts.interface";
export type { IConfig } from "./src/dbbl/interfaces/config.interface";

export type { IPKCE } from "./src/dbbl/interfaces/pkce.interface";

export { default as LibraryProvider } from "./src/dbbl/providers/library.provider";

export { default as ComposeProviders } from "./src/dbbl/providers/composeProviders";

export type * from "./src/dbbl/composites/request/request.types";
export * from "./src/dbbl/composites/request/request.types";

export * from "./src/dbbl/composites/request/request.helpers";
export * from "./src/dbbl/composites/request/request.hooks";

export type * from "./src/dbbl/composites/request/errors/errorHandler.types";
export * from "./src/dbbl/composites/request/errors/useErrorHandling.hook";
export * from "./src/dbbl/composites/request/request.utils";

export type * from "./src/types/models/v1/Error.types";
export * from "./src/types/models/v1/Error.types";
export * from "./src/types/models/v1/Feature.types";

export * from "./src/dbbl/hooks";

export {
  phoneFormatter,
  formatAddress,
  formatPhoneForDisplay,
  masks,
} from "./src/dbbl/utils";
export * from "./src/dbbl/hooks";

export {
  reducers,
  accountSortingActions,
  userActions,
  accountsActions,
  endToEndTestActions,
  selectEndToEndTest,
  type AccountsSliceState,
  useFetchInstitution,
  useFetchUser,
  useInstitutionHelpers,
  selectAccountSorting,
  selectAccountsById,
  selectBAccount,
  selectPayableLoanAccounts,
  selectLoansPayableByCard,
  selectGroupedLoanAccounts,
  selectAccounts,
  selectAllAccounts,
  selectInternalAccounts,
  selectMinimumPayment,
  selectAccountIdWithCertainty,
  selectGroupedLoanAccountsPayableByCard,
  selectVerifiedAccounts,
  selectDirectDepositEligibleAccountGroups,
  selectAccountNumber,
  createDeepEqualSelector,
  ACCOUNT_PRODUCT_GROUP,
  useUser,
  useCurrentUserFullName,
  createGroups,
  groupAccountsByOrganization,
  isBusinessUser,
  businessPermissions,
  dualApprovalRequired,
  achDualApprovalRequired,
  type RootState,
  type PreloadedState,
  DEFAULT_STATE,
} from "./src/dbbl/businessLogic/entities";

export * as entities from "./src/dbbl/businessLogic/entities";

export { createBootstrap } from "./src/dbbl/businessLogic/bootstrap";

export {
  centsToDollars,
  dollarsToCents,
  dollars,
  zeroDollars,
  zeroCents,
  cents,
  sanitizeTextCurrency,
  currencyToCents,
  getInForm,
  parseUrlLabel,
  formatScheduledDate,
} from "./src/dbbl/utils";

export type * from "./src/newBadge";
export * from "./src/newBadge";

export * from "./src/dbbl/businessLogic/modules";

// l10n exports
export * from "./src/l10n/SettingLocalizers";
export * from "./src/l10n/SettingFluentIds";
export * from "./src/l10n/Country";
export * from "./src/l10n/Occupation";
export * from "./src/l10n/Errors";
export * from "./src/l10n/InstanceHelpers";
export * from "./src/l10n/Debug";

export * from "./src/Recurrence";

export const modules = {
  achPayments,
  alerts,
  aoiob,
  auth,
  cardLimitIncrease,
  customAlerts,
  dashboard,
  directDeposit,
  externalAccounts,
  incomeReporting,
  internationalWires,
  loanPayment,
  nps,
  onboarding,
  positivePay,
  search,
  spendingIncome,
  subscriptions,
  transfers,
  travelNotes,
  userAccessibilityPreferences,
  userDisplayPreferences,
  userLanguagePreference,
  wireTemplates,
  narmiTiles,
};
